// import semantic ui for theming
// see https://medium.com/webmonkeys/webpack-2-semantic-ui-theming-a216ddf60daf
import './semantic-theme/semantic.less'

// import css
require('./style/style.css')
require('./style/datetime-picker.css')

// psw
require('./style/psw/photoswipe.css')
require('./style/psw/default-skin.css')

// bootstrap angular to index.html
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { AppModule } from './app/app.module'

platformBrowserDynamic().bootstrapModule(AppModule)



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./main.ts